<!--<img class="handleerror-img" [src]="imageUrl"-->
     <!--onerror="this.src='https://imgoingcalendar.com/assets/imgs/place-holder.jpg';this.onerror=null"-->
     <!--[width]="width" [height]="height" />-->

<img #image class="handleerror-img" [src]="imageUrl" [class.contain-image]="isContainImage"
     (error)="error()" [alt]="alt" (load)="loaded()"
     [width]="width" [height]="height" />


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/image/image.component.html